module.exports = __webpack_public_path__ + "static/industrial-services-2a8e4a63c64a741aa11a43f791d53830.png";